module.exports = __webpack_public_path__ + "static/media/glass_closedoor_left.bba10883.png";